import { addConnectionWkoManager, WKO_KEYS, Authentication, getWkoDispatchers } from '@owc/connection-wko-manager'
import { StreamSSE } from './store/interfaces'

declare global {
  interface Window {
    notificationsHubStandaloneMode: boolean
    streamsSSE?: StreamSSE[]
  }
}

const AUTH_OBJECT = {
  name: WKO_KEYS.authentication,
  value: {
    jwe: sessionStorage.getItem('ow_aem_jwe') || 'NO_TOKEN',
  } as Authentication,
}

const LOCALE_OBJECT = {
  name: WKO_KEYS.locale,
  value: {
    country: 'GB',
    language: 'en',
  },
}

const ENV_OBJECT = {
  name: WKO_KEYS.environment,
  value: {
    stage: 'INT',
    stageVariant: 'int',
  },
}

/**
 * Initializes Auth for standalone demo version (demo.html)
 * (not utilized in AEM context or local development)
 */
export const initDemoConfig = async (): Promise<void> => {
  await addConnectionWkoManager() // initialize WKO and Authentication for local development
  const wkoManagerConnection = await getWkoDispatchers()
  wkoManagerConnection.setWko(AUTH_OBJECT)
  wkoManagerConnection.setWko(LOCALE_OBJECT)
  wkoManagerConnection.setWko(ENV_OBJECT)
}
